// extracted by mini-css-extract-plugin
export default {"addToCartControl":"p1-z","giftCard":"q1-z","btnContainer":"r1-z","cartButton":"s1-z","disabled":"t1-z"};